import { numberToPrettyString } from '@cian/utils';

export function rangeAreaStr(prefix: string, gte?: number, lte?: number) {
  if (gte && lte) {
    return `${prefix} ${numberToPrettyString(gte)}–${numberToPrettyString(lte)} м²`;
  }
  if (gte) {
    return `${prefix} от ${numberToPrettyString(gte)} м²`;
  }
  if (lte) {
    return `${prefix} до ${numberToPrettyString(lte)} м²`;
  }

  return `${prefix} м²`;
}
